
import { Box, Typography, useTheme } from "@mui/material";      
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import { mockDataInvoices } from "../../data/mockData";
import Header from "../../components/Header";
import {  } from "@mui/material";
import { render } from "@testing-library/react";


const Invoices = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const columns = [   { field: "id", headerName: "ID"},
                        { field: "name", headerName: "Name", flex: 0.5, cellClassName: "name-column--cell"},
                        { field: "phone", headerName: "Phone Number", flex: 0.5},
                        { field: "email", headerName: "Email", flex: 0.5},
                        { field: "cost", headerName: "Cost",flex: 1, renderCell:(params) => (
                            <Typography m="18px 0 0 0" color={colors.greenAccent[500]}>
                                ${params.row.cost}
                            </Typography>
                        )},
                        { field: "date", headerName: "Date", flex: 1},
                    ]
    
    return (
        <Box m="20px">
            <Header title="INVOICES" subtitle="List of Invoices" /> 
            <Box
                m="40px 0 0 0"
                height="75vh"
                sx={{
                    "& .MuiDataGrid-root":{
                        border: "none"
                    },
                    "& .MuiDataGrid-cell":{
                        borderBottom: "none"
                    },
                    "& .name-column--cell":{
                        color: colors.greenAccent[300]
                    },
                    "& .MuiDataGrid-columnHeaders":{
                        backgroundColor: colors.blueAccent[200],
                        borderBottom: "none"
                    },
                    "& .MuiDataGrid-virtualScroller":{
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                }}
            >
                <DataGrid 
                    checkboxSelection
                    rows={mockDataInvoices}
                    columns={columns}
                    //slots={{ toolbar: CustomToolbar }}
                    //showToolbar
                />
            </Box>
        </Box>
    );
};

export default Invoices;